import React from 'react'

import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx'
import withStyles from '@material-ui/core/styles/withStyles'
import AssignmentInd from '@material-ui/icons/AssignmentInd'
import Work from '@material-ui/icons/Work'
import CloudUpload from '@material-ui/icons/CloudUpload'

import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import InfoArea from 'components/InfoArea/InfoArea.jsx'

const SessionNotes = ({ classes }) => (
    <div className={classes.section}>
        <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
                <h2 className={classes.title}>Session Notes & Document Management</h2>
                <h5 className={classes.description}>
          Who needs paper? You can lose it, you don't have a backup, and it
          isn't secure from prying eyes. We can take care of that for you.
                </h5>
            </GridItem>
        </GridContainer>
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Upload Documents"
                        description="Have Business Documents? Upload any document from HR to informational pamphlets for patients. We can help you share it with the right people and keep it safe from those who shouldn't see it."
                        icon={CloudUpload}
                        iconColor="info"
                        vertical
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Virtual Charts"
                        description="Each Patient has a virtual chart. Part of that chart is all of the notes you keep on the patient. You can write free form notes or follow templates. We have a built in reference to the DSM-5 to associate a diagnosis."
                        icon={AssignmentInd}
                        iconColor="success"
                        vertical
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Always Working For You"
                        description="In addition to manually added notes and information, we can add small notes as reminders to you. For instance, when a patient reschedules or misses an appointment we'll make note of it and keep your calendar up to date for you."
                        icon={Work}
                        iconColor="warning"
                        vertical
                    />
                </GridItem>
            </GridContainer>
        </div>
    </div>
)

export default withStyles(productStyle)(SessionNotes)



// WEBPACK FOOTER //
// ./src/views/Features/PracticeManagement/Sections/SessionNotes.jsx